export const POLYREAL = 'POLYREAL'